import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialog-paper': {
		borderRadius: '1rem',
		padding: '0 24px 24px 24px',
		width: '25rem',
		maxHeight: '37.5rem',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			margin: 0,
			padding: '0 12px 12px 12px',
		},
	},
}));

export const dialogStyles = {
	closeButton: {
		position: 'absolute',
		right: 0,
		top: '0.9375rem',
		color: (theme) => theme.palette?.accent03?.light,
	},
	dialogTitle: {
		margin: 0,
		padding: 3,
	},
	dialogContent: {
		maxHeight: '25rem',
		overflowY: 'auto',
		padding: '1.5rem 0',
	},
	title: {
		margin: '1rem 0',
	},
};
